export const suggestedSearchesConst: Array<string> = ['موبایل', 'لپ تاپ', 'هندزفری', 'سرخ کن', 'ماشین لباسشویی', 'سامسونگ'];
